import { render, staticRenderFns } from "./ShowImageModal.vue?vue&type=template&id=1085f6e4&lang=pug&"
import script from "./ShowImageModal.vue?vue&type=script&lang=ts&"
export * from "./ShowImageModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports